class EdBundleVariantSelect extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        let variantId = this.querySelector('input:checked').value;
        this.setAttribute('data-variant-id', variantId);
    }
}

customElements.define('ed-bundle-variant-select', EdBundleVariantSelect);

/** CART COMPONENTS **/
class EdBundleCartRemovePopup extends HTMLElement {
    constructor() {
        super();
        document.addEventListener('keydown', this.closeOnEsc.bind(this));

        // selectors
        this.closeButton = this.querySelector('.btn-close');
        this.abortButton = this.querySelector('.btn-abort');
        this.removeBundleButton = this.querySelector('.btn-remove');
        this.editBundleButton = this.querySelector('.btn-edit');

        this.closeButton.addEventListener('click', this.closeModal.bind(this));
        this.abortButton.addEventListener('click', this.closeModal.bind(this));
        this.removeBundleButton.addEventListener('click', this.removeBundleProducts.bind(this));
        this.editBundleButton.addEventListener('click', this.editBundleProducts.bind(this));
    }

    get bundleId() {
        return this.getAttribute('bundle-id');
    }

    get bundleUrl() {
        return this.getAttribute('bundle-url');
    }

    closeModal() {
        this.removeAttribute('open')
    }

    closeOnEsc(e) {
        if (e.key === 'Escape') {
            this.removeAttribute('open')
        }
    }

    editBundleProducts() {
        let cartItems = document.querySelector('cart-items');
        let bundleItems = cartItems.querySelectorAll('[data-bundle-id="' + this.bundleId + '"]');

        // let updates = [];
        // updates = [3, 0, 0, 0]

        let updates = {};

        bundleItems.forEach((item) => {
            let variantId = item.dataset.lineId.toString();
            updates[variantId] = 0;
        })

        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {updates})
            .done(() => {
                window.location.href = this.bundleUrl;
            });
        this.closeModal();
    }

    removeBundleProducts() {
        let cartItems = document.querySelector('cart-items');
        let bundleItems = cartItems.querySelectorAll('[data-bundle-id="' + this.bundleId + '"]');

        // let updates = [];
        // updates = [3, 0, 0, 0]

        let updates = {};

        bundleItems.forEach((item) => {
            let variantId = item.dataset.lineId.toString();
            updates[variantId] = 0;
        })

        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {updates})
            .done(() => {
                window.location.reload();
            });
        this.closeModal();
    }
}

customElements.define('ed-bundle-cart-remove-popup', EdBundleCartRemovePopup);
